import React from 'react';
import styled from 'styled-components';
import { IoCloseOutline } from 'react-icons/io5';

import ReusableModalPlain from './ReusableModalPlain';

/**
 *
 * Slightly opinionated modal with baked in support for header, title, subtitle close button, margins paddings etc..
 * use ReusableModalPlain for a more customisable modal
 *
 */

const ReusableModal: React.FC<Props> = ({ alignTop, title, onClose, onBack, subTitle, children, width }) => (
	<StyledModal
		wrapperStyle={{
			alignItems: alignTop ? 'flex-start' : 'center',
		}}
		$alignTop={alignTop}
		$width={width}
	>
		<ModalHeader $showBorder={!!title}>
			{onBack !== undefined ? <ModalBack onClick={onBack}>Back</ModalBack> : <EmptyBreak />}
			<ModalTitle>{title}</ModalTitle>
			{onClose !== undefined ? (
				<CloseWrapper>
					<button onClick={onClose}>
						<IoCloseOutline size={28} color="black" />
					</button>
				</CloseWrapper>
			) : (
				<EmptyBreak />
			)}
			{title && subTitle && (
				<>
					<FlexBreak />
					<ModalSubTitle>{subTitle}</ModalSubTitle>
				</>
			)}
		</ModalHeader>
		<ModalBody>{children}</ModalBody>
	</StyledModal>
);

export default ReusableModal;

interface Props {
	title?: string;
	onClose?: () => void;
	onBack?: () => void;
	subTitle?: React.ReactNode;
	showRG?: boolean;
	alignTop?: boolean;
	width?: string;
}

const StyledModal = styled(ReusableModalPlain)<{ $alignTop?: boolean; $width?: string }>`
	display: flex;
	flex-direction: column;
	width: ${({ $width = '416px' }) => $width};
	min-height: 350px;
	padding: 12px;
	max-height: 80vh;
	${({ $alignTop }) => ($alignTop ? 'margin-top: 5%;' : '')}
`;

const ModalHeader = styled.div<{ $showBorder: boolean }>`
	border-bottom: ${({ $showBorder }) => ($showBorder ? '1px' : '0px')} solid #ccc;
	min-height: 50px;
	width: 100%;
	display: inline-flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
	align-items: center;
`;

const ModalBody = styled.div`
	flex: 1;
	padding: 12px;
	overflow-y: scroll;
	overflow-x: hidden;
`;

const ModalBack = styled.button`
	font-size: 14px;
	line-height: 17px;
	height: 17px;
	color: #00549e;
	width: 30px;
`;

const CloseWrapper = styled.div`
	width: 30px;
`;

const ModalTitle = styled.h4`
	margin: 0;
	color: #000;
	font-size: 20px;
	line-height: 24px;
	font-weight: bolder;
	text-align: center;
	text-transform: uppercase;
`;

const EmptyBreak = styled.div`
	width: 14px;
`;

const FlexBreak = styled.div`
	height: 0;
	flex-basis: 100%;
`;

const ModalSubTitle = styled.span`
	font-size: 14px;
	font-weight: 400;
	text-align: center;
	color: #000;
	flex-basis: 100%;
`;
